module.exports = __webpack_public_path__ + "static/brogrammer2-0de74c0e4a65d09d342da0f15cf32ce8.gif";